import clsx from 'clsx';
import styles from './InputContent.module.scss';

import { useContext, type ReactNode } from 'react';
import { InputContext } from './InputContext';

type Align = 'start' | 'center' | 'end';

interface Props {
  children: ReactNode | ((args: { id: string }) => ReactNode);
  align?: Align;
}

export function InputContent(props: Props) {
  const inputContext = useContext(InputContext);
  const algin = props.align ?? 'start';
  const className = clsx(styles['root'], styles[`align-${algin}`]);

  if (!inputContext) {
    return <pre>InputContent used outside of Input contenxt.</pre>;
  }

  const { id } = inputContext;
  const children =
    typeof props.children === 'function'
      ? props.children({ id })
      : props.children;

  return <div className={className}>{children}</div>;
}
